<template>
  <NotBlankPage
      maxWidth="calc(100% - 80px)"
      :hasBackLink="true"
      failLink="/wages"
      itemKey="Wage"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setBreadcrumbs="setBreadcrumbs"
  >
    <template
        v-slot:default="{
          Item,
          refresh
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <TicketItemReports
              :Wage="Item"
              @refresh="refresh"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <TicketBonuses
              :Wage="Item"
              @refresh="refresh"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <TicketCommissions
              :Wage="Item"
              @refresh="refresh"
          />
        </v-col>
      </v-row>
    </template>
  </NotBlankPage>
</template>

<script>
  import Wages from '@/services/wages'

  import TicketItemReports from '@/components/Wage/TicketItemReports'
  import TicketBonuses from '@/components/Wage/TicketBonuses'
  import TicketCommissions from '@/components/Wage/TicketCommissions'

  import NotBlankPage from '@/components/_Part/_Page/NotBlank'

  export default {
    name: 'Wage',
    components: {
      TicketItemReports,
      TicketBonuses,
      TicketCommissions,
      NotBlankPage
    },
    methods: {
      fetchData() {
        return Wages
          .read({
            id: this.$route.params.id
          })
      },
      setTitle(Item) {
        if (Item.Closing.closedAt) {
          return this.$moment(Item.Closing?.closedAt).format('MM/YYYY')
        } else {
          return 'Neuzavreté'
        }
      },
      setBreadcrumbs(Item) {
        return [
          {
            text: 'Manažment',
            to: '/management'
          },
          {
            text: Item.User.name,
            to: '/management/' + Item.User.id
          }
        ]
      }
    }
  }
</script>
